import { TransactionRequest } from '@ethersproject/abstract-provider';

export type SymbiosisRevertResponse = {
    tx: TransactionRequest;
};
